/** Traductions tableau de bord pharmacie (FR / AR) */
export const pharmacyDashboardFr = {
  tabOverview: 'Vue d\'ensemble',
  tabLots: 'Lots',
  wrongBusinessTitle: 'Tableau pharmacie',
  wrongBusinessMessage: 'Ce tableau de bord est réservé aux établissements de type pharmacie.',
  loading: 'Chargement…',
  title: 'Pharmacie',
  subtitle: 'Conformité et lots — vue unifiée au même standard visuel que le reste de l\'application.',
  refresh: 'Actualiser',
  metricTotalLots: 'Total lots',
  metricCompliantLots: 'Lots conformes',
  metricNonCompliant: 'Non conformes',
  metricComplianceScore: 'Score conformité',
  recentIssues: 'Écarts récents',
  details: 'Détails',
  quickActions: 'Actions rapides',
  report: 'Rapport'
};

export const pharmacyDashboardAr = {
  tabOverview: 'نظرة عامة',
  tabLots: 'الدفعات',
  wrongBusinessTitle: 'لوحة الصيدلية',
  wrongBusinessMessage: 'هذه اللوحة متاحة فقط لنوع نشاط «صيدلية».',
  loading: 'جاري التحميل…',
  title: 'الصيدلية',
  subtitle: 'الامتثال والدفعات — لوحة موحدة بنفس أسلوب التطبيق.',
  refresh: 'تحديث',
  metricTotalLots: 'إجمالي الدفعات',
  metricCompliantLots: 'دفعات ملتزمة',
  metricNonCompliant: 'غير ملتزمة',
  metricComplianceScore: 'درجة الامتثال',
  recentIssues: 'مخالفات حديثة',
  details: 'تفاصيل',
  quickActions: 'إجراءات سريعة',
  report: 'تقرير'
};
